import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  background: linear-gradient(to right, #2F4F4F, #1c2f2f);
  color: white;
  padding: 4rem 0 1rem 0;
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 0 2rem;
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FooterTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #fff;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    right: 0;
    bottom: -8px;
    width: 40px;
    height: 3px;
    background: #8fbc8f;
  }
`;

export const FooterLink = styled.a`
  color: #e3f2fd;
  text-decoration: none;
  margin: 0.5rem 0;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #8fbc8f;
    transform: translateX(-5px);
  }
`;

export const FooterText = styled.a`
  color: #e3f2fd;
  text-decoration: none;
  margin: 0.5rem 0;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
  
  &:hover {
    color: #8fbc8f;
  }
`;

export const CalculatorLink = styled(FooterLink)`
  background: rgba(255, 255, 255, 0.1);
  padding: 0.5rem 1rem;
  border-radius: 5px;
  margin-top: 1rem;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const SocialMediaContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

export const SocialIcon = styled.a`
  color: white;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  &:hover {
    background: #2F4F4F;
    transform: translateY(-3px);
  }
`;

export const NewsletterSection = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const NewsletterInput = styled.input`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  
  &::placeholder {
    color: #e3f2fd;
  }
`;

export const SubscribeButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  background: #2F4F4F;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #1c2f2f;
  }
`;

export const FooterBottom = styled.div`
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`; 